module.exports = __webpack_public_path__ + "img/menu.f38f9e06.svg";